/**
 * @description Configuración de tamaños.
 */
const sizeConfigs = {
    sidebar: {
        width: "25vw", // "300px",
        item:{
            marginY: "0.7rem",
            marginX: "1.5rem",
        },
        itemCollapse: {
            paddingX: "0rem",
            marginX: "0.1rem",
        }
    }
};

export default sizeConfigs;
